import { forwardRef } from "react"

import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu"
import { Icon, IconX } from "@tabler/icons-react"

import { cn } from "@/lib/utils"

import { Truncate } from "../../Truncate"

export interface FilterPillProps {
  id?: string
  label: string
  onRemove?: () => void
  active?: boolean
  icon?: Icon
}

export const FilterPill = forwardRef<HTMLSpanElement, FilterPillProps>(
  function FilterPill({ id, label, active, onRemove, icon, ...props }, ref) {
    const Icon = icon

    return (
      <span
        ref={ref}
        id={id}
        className={cn(
          "grid w-fit max-w-[300px] cursor-pointer grid-cols-[auto_1fr] items-center overflow-hidden rounded border border-grey-400 text-body2 text-colors-text-secondary",

          "hover:border-colors-border-hover aria-selected:border-colors-border-hover aria-selected:bg-brand-secondary-200 aria-selected:text-colors-text-secondary",
          {
            "border-brand-secondary-500 bg-brand-primary-100 text-brand-secondary-700":
              active,
          },
        )}
        {...props}
      >
        <DropdownMenuTrigger
          className={cn(
            "peer flex min-w-0 items-center gap-2 py-1 pr-1 pl-3",
            "outline-hidden hover:bg-brand-secondary-200 hover:text-colors-text-secondary focus:bg-brand-secondary-200 focus:text-colors-text-secondary",
            { "pr-3": !onRemove },
          )}
        >
          {Icon ? <Icon /> : null}
          <span className="overflow-hidden">
            <Truncate text={label} />
          </span>
        </DropdownMenuTrigger>
        {onRemove ? (
          <button
            type="button"
            className="group h-full px-1 outline-hidden peer-hover:bg-brand-secondary-200 peer-hover:text-colors-text-secondary focus:bg-brand-secondary-200 focus:text-colors-text-secondary"
            onClick={(e) => {
              e.stopPropagation()
              onRemove()
            }}
          >
            <span className="flex rounded-full p-1 group-hover:bg-brand-secondary-200 group-hover:text-colors-text-secondary">
              <IconX size={14} />
            </span>
          </button>
        ) : null}
      </span>
    )
  },
)
